import styled from '@emotion/styled';
import { Radio, FieldList, Badge, tokens } from '@hotjar/hotsauce';
import { useTranslationWithPrefix } from '@hotjar/translations';
import type { BillingPeriod } from '../../../../../../api/common/model/subscription';

const S = {
  Heading: styled.h3`
    ${tokens.text('subtitle1')}
    margin-bottom: ${tokens.spacer.x3};
  `,
  Row: styled.span`
    display: flex;
    align-items: center;
    gap: ${tokens.spacer.x5};
  `,
  Badge: styled(Badge)`
    background-color: ${tokens.color.bg_success};
    margin-right: ${tokens.spacer.x0};
  `,
  Radio: styled(Radio)`
    margin-bottom: 0;
  `,
};

interface Props {
  onSelect: (period: BillingPeriod) => void;
  billingPeriod: BillingPeriod;
  showYearlyDiscount: boolean;
  isDisabled?: boolean;
}

export function BillingPeriodSelector({
  onSelect,
  billingPeriod,
  showYearlyDiscount,
  isDisabled = false,
}: Props): JSX.Element {
  const { t } = useTranslationWithPrefix('checkout:wizard.billing-period');
  return (
    <>
      <S.Heading as="p">{t('title')}</S.Heading>
      <FieldList title="">
        <S.Row>
          <S.Radio
            name="billing-period"
            value="ANNUALLY"
            labelContent={t('pay-yearly')}
            isChecked={billingPeriod === 'ANNUALLY'}
            isDisabled={isDisabled}
            onChange={() => onSelect('ANNUALLY')}
          />
          {showYearlyDiscount && (
            <S.Badge textColor={tokens.color.text_success} kind="custom">
              {t('yearly-discount')}
            </S.Badge>
          )}
        </S.Row>
        <S.Row>
          <S.Radio
            name="billing-period"
            value="MONTHLY"
            labelContent={t('pay-monthly')}
            isChecked={billingPeriod === 'MONTHLY'}
            isDisabled={isDisabled}
            onChange={() => onSelect('MONTHLY')}
          />
        </S.Row>
      </FieldList>
    </>
  );
}
